<template>
	<div style="min-width: 100px;" v-if="plate_code">

		<div class="row">
			<div class="col-1 border alert-primary">N</div>
			<div class="col alert-danger border" v-bind:key="plate.index" v-for="plate in plates">
				<div>
					<span class="badge badge-light" @click="showPlateKline(plate['code'], plate['name'])" style="cursor: pointer;">{{plate['name']}}</span>
					<span class="badge badge-light" v-if="show_count">{{ getPlateNonBrokenStockCount(plate['code']) }}</span>
				</div>
				<div>
					<span class="badge badge-info" v-if="show_score">{{ plate['score'] }}</span>
					<span class="badge badge-warning" v-if="plate['rate']">{{ plate['rate'].toFixed(2) }}%</span>
				</div>
			</div>
		</div>

		<div class="row" v-bind:key="ban.index" v-for="ban in bans">
			<div v-if="ban==0" class="col-1 border alert-danger">0</div>
			<div v-else class="col-1 border alert-danger">{{ban}}</div>
			
			<div class="col border" style="padding: 0;" v-bind:key="plate.index" v-for="plate in plates">
				<!-- {{ban}} {{plate['code']}} {{stocks_plate[ban][plate['code']]}} -->
				<div class="stock_item_block" v-bind:key="stock.index" v-for="stock in stocks_plate[ban][plate['code']]">
					<!-- {{stock["up_limit_time"]}} {{stock['stock_name']}} {{stock['next_close_pct']}} -->
					<StockMarketItem 
						@show_sidebar="show_sidebar" 
						:is_show_market=status_market 
						:stock_info="stock" 
						:market="stock['market']" 
						:show_time="show_time" 
						:show_amount="show_amount"
						:show_market_value="show_market_value"
						:show_circulating_value="show_circulating_value"
						:show_sealed_order="show_sealed_order"
					></StockMarketItem>
					<div v-if="showMinChart" class="plate-min-chart-placeholder border-bottom" :data-stock-code="stock.stock_code" style="min-height: 50px;">
						<StockMiniTrend 
							v-if="visibleStocks[stock.stock_code]" 
							:symbol_code="stock.stock_code" 
							:selected_date="date1"
							chart_heigh="50px"
						></StockMiniTrend>
						<div v-else class="d-flex justify-content-center align-items-center" style="height: 50px; background: #f8f9fa;">
							<span class="text-muted small" style="font-size: 10px;">载入中...</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		
	</div>
</template>

<script>
	import StockMarketItem from 'components/stock/StockMarketItem.vue'
	import StockMiniTrend from "../stock/StockMiniTrend"

	import {
		request_zzquant
	} from "network/request.js"

	export default {
		props:{
			// status_market:{type:Number,default:0}	
			plate_code:{type:String,default:""},
			date1:{type:String,default:""},
			showMinChart:{type:Boolean,default:false}
		},
		
		components: {
			StockMarketItem,
			StockMiniTrend
		},
		mounted() {
			// console.log("mounted");
			// this.update_info();
			// 从localStorage读取状态
			const savedMarketStatus = localStorage.getItem('uplimit_status_market');
			const savedShowCount = localStorage.getItem('uplimit_show_count');
			const savedShowTime = localStorage.getItem('uplimit_show_time');
			const savedShowTopN = localStorage.getItem('uplimit_show_top_n');
			const savedShowScore = localStorage.getItem('uplimit_show_score');
			const savedShowAmount = localStorage.getItem('uplimit_show_amount');
			const savedShowMarketValue = localStorage.getItem('uplimit_show_market_value');
			const savedShowCirculatingValue = localStorage.getItem('uplimit_show_circulating_value');
			const savedShowSealedOrder = localStorage.getItem('uplimit_show_sealed_order');
			
			if (savedMarketStatus !== null) {
				this.status_market = parseInt(savedMarketStatus);
			}
			
			if (savedShowCount !== null) {
				this.show_count = parseInt(savedShowCount);
			}
			
			if (savedShowTime !== null) {
				this.show_time = parseInt(savedShowTime);
			}
			
			if (savedShowTopN !== null) {
				this.show_top_n = parseInt(savedShowTopN);
			}
			
			if (savedShowScore !== null) {
				this.show_score = parseInt(savedShowScore);
			}
			
			if (savedShowAmount !== null) {
				this.show_amount = parseInt(savedShowAmount);
			}
			
			if (savedShowMarketValue !== null) {
				this.show_market_value = parseInt(savedShowMarketValue);
			}
			
			if (savedShowCirculatingValue !== null) {
				this.show_circulating_value = parseInt(savedShowCirculatingValue);
			}
			
			if (savedShowSealedOrder !== null) {
				this.show_sealed_order = parseInt(savedShowSealedOrder);
			}
			
			// 获取交易日期
			// request_zrx({url:'/open/tradedays'}).then(
			// 	res => {
			// 		let days = res['data']['data']
			// 		this.date1 = days[days.length-1];
			// 		// 加载数据
			// 		this.update_info(this.date1);
			// 	}
			// );
			this.update_info(this.date1);
			if(this.showMinChart) {
				this.$nextTick(this.initObserver)
			}
		},
		beforeDestroy(){ 
			if(this.observer){ this.observer.disconnect() }
		},
		watch:{
			showMinChart(val) {
				if(val) {
					this.$nextTick(this.initObserver)
				} else {
					if(this.observer) {
						this.observer.disconnect()
						this.observer = null
					}
					this.visibleStocks = {}
				}
			},
			// status_market:this.update_info
			status_market(newVal) {
				localStorage.setItem('uplimit_status_market', newVal);
				this.update_info(this.date1);
			},
			show_count(newVal) {
				localStorage.setItem('uplimit_show_count', newVal);
			},
			show_time(newVal) {
				localStorage.setItem('uplimit_show_time', newVal);
			},
			show_top_n(newVal) {
				localStorage.setItem('uplimit_show_top_n', newVal);
				// 当改变板块数量时，重新加载数据
				this.update_info(this.date1);
			},
			show_score(newVal) {
				localStorage.setItem('uplimit_show_score', newVal);
			},
			show_amount(newVal) {
				localStorage.setItem('uplimit_show_amount', newVal);
			},
			show_market_value(newVal) {
				localStorage.setItem('uplimit_show_market_value', newVal);
			},
			show_circulating_value(newVal) {
				localStorage.setItem('uplimit_show_circulating_value', newVal);
			},
			show_sealed_order(newVal) {
				localStorage.setItem('uplimit_show_sealed_order', newVal);
			},
			plate_code (newVal) {
				if(newVal){
				this.update_info();
			}
			},
			date1(newVal) {
				if(newVal){
				this.update_info();
				}
			},
		},
		data() {
			const now = new Date();
			const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
			return {
				visibleStocks: {},
				observer: null,
				status_market: 0,
				show_count: 1, // 修改为默认显示涨停个数
				show_time: 1, // 默认显示时间
				show_score: 0, // 默认不显示分数
				show_amount: 0, // 默认不显示成交额
				show_market_value: 0, // 默认不显示市值
				show_circulating_value: 0, // 默认不显示流通市值
				show_sealed_order: 0, // 默认不显示封单
				show_top_n: 12, // 默认显示12个板块
				topNOptions: [
					{ value: 5, text: '显示板块: 5个' },
					{ value: 8, text: '显示板块: 8个' },
					{ value: 10, text: '显示板块: 10个' },
					{ value: 12, text: '显示板块: 12个' },
					{ value: 15, text: '显示板块: 15个' },
					{ value: 20, text: '显示板块: 20个' }
				],
				today: today,
				bans: [5, 4, 3, "炸"],
				ban_info: {},
				plates: [{
					"name": "loading...",
					"code": "8001",
					"score":0,
				}, 
			],
				stocks_plate: {
					"5": {
						"8001": [{
							"stock_name": "loading...",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}],
						"8002": [],
						"8003": [{
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}],
					},
					"4": {
						"8001": [{
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}],
						"8002": [],
						"8003": [],
					},
					"3": {
						"8001": [{
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}],
						"8002": [],
						"8003": [],
					},
					"炸": {
						"8001": [{
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}],
						"8002": [],
						"8003": [],
					},
				},
			};
		},

		methods: {
			initObserver() {
				if (this.observer) {
					this.observer.disconnect();
				}
				this.observer = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							const stockCode = entry.target.dataset.stockCode;
							if (stockCode && !this.visibleStocks[stockCode]) {
								this.$set(this.visibleStocks, stockCode, true);
								this.observer.unobserve(entry.target);
							}
						}
					});
				}, {
					rootMargin: '100px'
				});
				this.observeStockRows();
			},
			observeStockRows() {
				if (!this.observer) return;
				const elements = this.$el.querySelectorAll('.plate-min-chart-placeholder');
				elements.forEach(el => {
					if (!this.visibleStocks[el.dataset.stockCode]) {
						this.observer.observe(el);
					}
				});
			},
			show_sidebar(stock_info){
				this.$emit('show_sidebar',stock_info)
			},
			click_show_market(){
				// console.log("click");
				this.update_info(this.date1);
			},
			onDatePicked(ctx) {
				// console.log(ctx.selectedYMD);
				this.date1 = ctx.selectedYMD;
				// console.log(this.date1);
				this.update_info(this.date1);
			},
			showPlateKline(plateCode, plateName) {
				this.$emit('show-plate-kline', { code: plateCode, name: plateName });
			},
			get_plate_stocks() {
				// Implementation for getting plate stocks
				this.update_info(this.date1);
			},
			dateDisabled(ymd, date) {
				const weekday = date.getDay();
				const time = date.getTime()

				const now = new Date();
				const now_time = now.getTime();
				// 周六日不能选
				if (weekday === 0 || weekday === 6) {
					return true;
				}
				//今天之后不能选
				if (time >= now_time) {
					return true;
				}
				return false
			},
			real_time_info_stock(real_time_stocks,stock) {
				
				if(!real_time_stocks) return false;
				
				var fields = real_time_stocks['fields']
				var values = real_time_stocks['values']
				
				var idx = fields.indexOf(stock)
				// console.log(fields,values,stock,idx);
				if(idx > -1){
					return values[idx]
				}
				return false
			},
			getPlateNonBrokenStockCount(plateCode) {
				let count = 0;
				for (let ban in this.stocks_plate) {
				if (ban != 0 && this.stocks_plate[ban][plateCode]) {
					count += this.stocks_plate[ban][plateCode].length;
				}
				}
				return count;
			},
			update_table_info(res,res2){
				// console.log(res2);
				let data = res['data']['data'];
				let plates = data['plate'];
				let plate_stocks = data['plate_stocks']
				let ban_info = data['ban_info'] || {}; // 获取ban_info数据
				this.ban_info = ban_info;
				// 更新板块显示
				let plate_arr = [];
                plates.forEach((item) => {
                    plate_arr.push({
                        "name": item[0],
                        "code": item[1],
                        "score": item[2]
                    })
                });
				// // 添加其他版块
				// plate_arr.push({
				// 	"name": '其他',
				// 	"code": '000000',
				// 	"score": 0
				// })
				this.plates = plate_arr;
				
				// 更新最高板数梯队
				let ban_arr = [];
				for (let i = data.max_count; i > -1; i--) {
					ban_arr.push(i);
				}
				// ban_arr.push(0)
				this.bans = ban_arr;
				
				// 更新板块下的股票列表
				let stocks_plate_dict = {};
				
				for (let idx in ban_arr) { //从高到低的板数梯队
					let ban = ban_arr[idx]
					stocks_plate_dict[ban] = {}
					plates.forEach((item) => {
						let plate_code = item[1]
						stocks_plate_dict[ban][plate_code] = [] //某板块下的数据
						let stocks_on_plate = plate_stocks[plate_code] //股票列表
						stocks_on_plate.forEach((item2) => {
							if (item2['up_limit_keep_times'] == ban) {
								if(this.status_market==1 && res2){
									let market = this.real_time_info_stock(res2['data']['data'],item2['stock_code']);
									// console.log(market);
									item2['market']  = market;
								}else{
									item2['market']  = {"px_change_rate":0,"open_px_rate":0}
								}
								stocks_plate_dict[ban][plate_code].push(item2)
								// console.log(ban,plate_code,stocks_plate_dict[ban][plate_code]);
							}
						})
						// 按照时间正序排序
						stocks_plate_dict[ban][plate_code].sort((a, b) => {
							const t1 = a.up_limit_time || '';
							const t2 = b.up_limit_time || '';
							return t1.localeCompare(t2);
						});
					});
				}
				this.stocks_plate = stocks_plate_dict;
				if(this.showMinChart) {
					this.$nextTick(this.observeStockRows);
				}
			},
			update_info() {
				// console.log(self.date1);
				if(!this.plate_code || !this.date1) return;
                request_zzquant({
                    url: 'v3/open/review/uplimit/hot?date1=' + this.date1 + '&board=' + this.plate_code + '&limit=' + this.show_top_n,
                }).then(res => {
					if(this.status_market==1){
						let data = res['data']['data'];
						if (data['stocks'].length==0){
							this.update_table_info(res);
							return
						}
						request_zzquant({
							url: '/open/market/real?symbols='+data['stocks']
						}).then(res2 => {
							this.update_table_info(res,res2);
						})
					}else{
						this.update_table_info(res)
					}
				})
			}
		},

		}
</script>

<style>
.stock_item_block{
	font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
	font-size: 14px;
	line-height: 1.42857143;
	color: #333;
	background-color: #fff;
	margin-left: 0px;
	/* border: 1px solid #EC0000; */
}

/* 添加badge样式 */
.badge {
  margin-left: 5px;
  font-size: 12px;
  background-color: #fff;
  color: #dc3545;
  border: 1px solid #dc3545;
}
</style>
